import { createAPIActions, createActions } from '../../utils/redux-actions';

export const satellite = createAPIActions('SATELLITE');
export const satelliteWithTrajectory = createAPIActions('SATELLITE_WITH_TRAJECTORY');
export const satellites = createAPIActions('SATELLITES');
export const setSatellitesSelected = createActions('SELECT_SATELLITES');
